export default __webpack_public_path__ + "static/media/Hauora-Bold.0759b43c.woff";